import { render, staticRenderFns } from "./DashboardCampaignData.vue?vue&type=template&id=c693e59c&scoped=true&"
import script from "./DashboardCampaignData.vue?vue&type=script&lang=js&"
export * from "./DashboardCampaignData.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCampaignData.vue?vue&type=style&index=0&id=c693e59c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c693e59c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VFlex,VIcon,VLayout,VProgressLinear})
